import React, { useState } from 'react';
import { DataTableType } from '@/components/common/Table/index';

export const useTableHelpers = () => {
  const [sortBy, setSortBy] = useState<keyof DataTableType>('created');
  const [DESC, setDESC] = useState(true);
  const [page, setPage] = useState(1);
  const [tableData, setTableData] = useState<DataTableType[]>([]);

  const toggleSort = (type: keyof DataTableType) => {
    if (sortBy !== type) {
      setDESC(true);
      setSortBy(type);
    } else {
      setDESC(!DESC);
    }
  };

  // "page-1" not just "page" needed because pagination on BE starts from page:0
  return { sortBy: sortBy as string, isDesc: DESC, toggleSort, page: page - 1, setPage, tableData, setTableData };
};
